import createSortedAssetsSelectorFactory from './create-sorted-assets-selector-factory.js';
import enabledAssetsSelector from '../../assets/selectors/enabled-assets.js';

const createSortedEnabledAssetsSelector = createSortedAssetsSelectorFactory(
  enabledAssetsSelector,
);

export default createSortedEnabledAssetsSelector;
